import { cn } from '@opoint/infomedia-storybook'
import { Trans } from 'react-i18next'
import { useMemo } from 'react'
import { getAlertsList, getAlertsRecipients } from '../../../../../selectors/alertsSelectors'
import { useAppSelector } from '../../../../hooks/useAppSelector'
import { useNavigationContext } from '../../NavigationContext'
import {
  NavigationSectionContent,
  NavigationSectionEmptySearchMessage,
  NavigationSectionSearchItem,
  NavigationSectionSearchItemLink,
} from '../../primitives/NavigationSection'
import { getSearchedAlerts } from '../../../../helpers/alerts'

const AlertsNavigationListHeader = ({ active }: { active?: boolean }) => {
  return (
    <div className="mb-1 flex items-center gap-1.5 pl-4">
      <span className={cn('size-2 shrink-0 rounded-full', { 'bg-forest.3': active, 'bg-berry.1': !active })} />
      <span className="text-xs font-bold uppercase text-sky.1">
        {active ? <Trans>Active</Trans> : <Trans>inActive</Trans>}
      </span>
    </div>
  )
}

export const AlertsNavigationList = () => {
  const { searchQuery } = useNavigationContext()

  const alerts = useAppSelector(getAlertsList)
  const recipients = useAppSelector(getAlertsRecipients)

  const filteredRecipients = useMemo(
    () => getSearchedAlerts(alerts, recipients, searchQuery),
    [alerts, recipients, searchQuery],
  )

  const activeRecipients = filteredRecipients.filter((recipient) => recipient.active)
  const inactiveRecipients = filteredRecipients.filter((recipient) => !recipient.active)

  if (!searchQuery) {
    return null
  }

  return (
    <NavigationSectionContent>
      {!filteredRecipients.length ? (
        <NavigationSectionEmptySearchMessage />
      ) : (
        <div className="flex flex-col gap-3">
          {activeRecipients.length > 0 && (
            <div>
              <AlertsNavigationListHeader active />

              {activeRecipients.map(({ id, subject }) => (
                <NavigationSectionSearchItem key={id}>
                  <NavigationSectionSearchItemLink to={`/alerts/${id}`}>{subject}</NavigationSectionSearchItemLink>
                </NavigationSectionSearchItem>
              ))}
            </div>
          )}
          {inactiveRecipients.length > 0 && (
            <div>
              <AlertsNavigationListHeader />

              {inactiveRecipients.map(({ id, subject }) => (
                <NavigationSectionSearchItem key={id}>
                  <NavigationSectionSearchItemLink to={`/alerts/${id}`}>{subject}</NavigationSectionSearchItemLink>
                </NavigationSectionSearchItem>
              ))}
            </div>
          )}
        </div>
      )}
    </NavigationSectionContent>
  )
}
